export const getBreakpoint = (screenWidth) => {
    const mobile = 483;
    const tablet = 992;
    if (screenWidth < mobile) {
        return 'mobile';
    }
    else if (screenWidth < tablet) {
        return 'tablet';
    }
    else {
        return 'desktop';
    }
};
//# sourceMappingURL=getBreakpoint.js.map